/*
 * Copyright (c) 2021 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

/** Здесь храним и обновляем динамические данные**/

import Chain from '@/services/chain';
import eventBus from '@/plugins/event-bus';
import CryptoJS from "crypto-js";

export default {
    namespaced: true,

    state: {
        account: {},
    },

    getters: {
        account: state => state.account,
    },

    mutations: {
        SET_RESET(state) {
            state.account = {};
        },
        SET_ACCOUNT(state, payload) {
            state.account = payload;
        },
    },

    actions: {
        reset({commit}) {
            commit('SET_RESET')
        },
        async subscribeAccount({commit}, value) {
            await Chain.subscribeAccount(value);
        },
        async setAccount({ commit }, values) {
            commit('SET_ACCOUNT', values);
        },
        async loginValidate({ commit }, value) {
            const pinEncrypted = this.getters['app/pinEncrypted'];
            const currentHashPin = (CryptoJS.SHA384(value)).toString();
            const decryptCompare = (CryptoJS.AES.decrypt(pinEncrypted, currentHashPin)).toString(CryptoJS.enc.Utf8)

        },

    }
}
